import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { nutritionAPI } from '../../services/api'

export function FoodPicker({ onPick, onCancel, withQuantity = false, initialQuantity = 100, initialQuery = '' }) {
  const { t } = useTranslation()
  const [q, setQ] = useState(initialQuery)
  const [quantity, setQuantity] = useState(initialQuantity)
  const search = useQuery({
    queryKey: ['mealPrepFoodSearch', q],
    queryFn: () => nutritionAPI.searchFoods(q).then((r) => r.data?.foods ?? []),
    enabled: q.trim().length >= 2,
  })
  return (
    <div className="border rounded-lg p-2 space-y-2 bg-surface-container" data-testid="food-picker">
      <div className="flex flex-wrap gap-2">
        <input
          autoFocus
          className="border rounded px-2 py-1 text-sm flex-1 min-w-0"
          placeholder={t('mealPrep.picker.placeholder')}
          aria-label={t('mealPrep.picker.placeholder')}
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
        {withQuantity && (
          <input
            type="number" min="1" max="5000"
            className="border rounded px-2 py-1 text-sm w-24"
            aria-label={t('mealPrep.editor.quantity')}
            value={quantity}
            onChange={(e) => setQuantity(Number(e.target.value))}
          />
        )}
        <button type="button" className="text-sm underline" onClick={onCancel}>{t('mealPrep.actions.cancel')}</button>
      </div>
      {search.isLoading && q.trim().length >= 2 && <p className="text-xs text-gray-500">{t('mealPrep.picker.searching')}</p>}
      {search.isError && <p className="text-xs text-red-600">{t('mealPrep.errors.generic')}</p>}
      {search.data?.length === 0 && <p className="text-xs text-gray-500">{t('mealPrep.picker.noResults')}</p>}
      <ul className="space-y-1">
        {(search.data ?? []).map((food) => (
          <li key={food.id}>
            <button
              type="button"
              className="text-sm text-left w-full px-2 py-1 rounded hover:bg-gray-100"
              onClick={() => onPick({ food_id: food.id, name: food.name, quantity_g: quantity })}
            >
              {food.name}{food.brand ? ` (${food.brand})` : ''}
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default FoodPicker
